export const settingsButtonDataSet = { cy: 'settings-button' };
export const settingsContainerDataSet = { cy: 'settings-container' };
